import { forwardRef, Fragment, ReactNode } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { XMarkIcon } from "@heroicons/react/20/solid";

export type UiDialogInputProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  title: string;
};

const UiDialog = forwardRef<typeof Dialog, UiDialogInputProps>(
  ({ open, onClose, children, className, title }, ref) => {
    return (
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          open={open}
          className={classNames("relative z-[9999]")}
          onClose={onClose}
          ref={ref as any}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={classNames(
                    "absolute inset-0 rounded-none",
                    "md:static md:rounded-2xl",
                    "transform overflow-hidden bg-white p-6 text-left align-middle shadow-xl transition-all",
                    className,
                  )}
                >
                  <div className="mb-4 flex items-center justify-between">
                    <Dialog.Title as="h3">{title}</Dialog.Title>
                    <button
                      className="text-th-primary-900"
                      onClick={onClose}
                      title="Schliessen"
                    >
                      <XMarkIcon className="h-8 w-8" />
                    </button>
                  </div>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  },
);

UiDialog.displayName = "UiDialog";

export default UiDialog;
